import { render, staticRenderFns } from "./HandledList.vue?vue&type=template&id=8b670b2e"
import script from "./HandledList.vue?vue&type=script&lang=js"
export * from "./HandledList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports